<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 sm12 md12 lg9 xl8 class="pa-2">
            <h2>PLAČILNE LISTE</h2>
            <empty-space/>
            <p>Na spodnjem seznamu se nahajajo vse vaše prejete plačilne liste. Prosimo, da si jih skrbno prenašate in
                shranite v svoj osebni arhiv.</p>

            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">
                            Plačilna lista
                        </th>
                        <th>
                            Prenešeno
                        </th>
                        <th class="text-left">
                            Akcija
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                            v-for="item in payrolls"
                            :key="item.name"
                    >
                        <td>{{ item.name }}</td>
                        <td>
                            <v-icon v-if="item.downloaded" color="primary">fas fa-check-circle</v-icon>
                            <v-icon v-if="!item.downloaded" color="red darken-3">fas fa-exclamation-triangle</v-icon>
                        </td>
                        <td>
                            <v-btn text color="primary" @click="downloadFile(item)" target="_blank">Prenos
                                datoteke
                                <v-icon small right>fas fa-download</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import {tusTeamService} from "../../services";
    import EmptySpace from "../../components/EmptySpace";

    export default {
        name: "PayrollTab",
        components: {EmptySpace},
        data() {
            return {
                payrolls: [],
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                return tusTeamService.getPayrolls().then(
                    (data) => {
                        this.payrolls = data;
                    }, (error) => {
                        console.log(error);
                    });
            },
            downloadFile(item) {
                item.downloaded = true;
                window.open(item.download_url);
            }
        }
    }
</script>

<style scoped>

</style>